<template>
  <span class="admin-image" :style="{width:dimension(width),height:dimension(height)}"><AntImage v-bind="$attrs" :src="src" :width="width" :height="height" :preview="false" @click="open"/><AdminImagePreview v-if="opened" v-model:visible="opened" :src="fullSource" :title="String($attrs.alt || '')" /></span>
</template>
<script lang="ts">export default {inheritAttrs:false}</script>
<script setup lang="ts">
import {computed,ref} from 'vue'
import {Image as AntImage} from 'ant-design-vue'
import AdminImagePreview from './AdminImagePreview.vue'
import {previewImageUrl} from '@/utils/adminImage'
const props=withDefaults(defineProps<{src?:string;width?:string|number;height?:string|number;preview?:boolean|Record<string,any>}>(),{src:'',preview:true})
const opened=ref(false)
const fullSource=computed(()=>typeof props.preview==='object' && props.preview.src?props.preview.src:previewImageUrl(props.src))
function dimension(value?:string|number){return typeof value==='number'?value+'px':value}
function open(){if(props.preview!==false && props.src)opened.value=true}
</script>
<style>
.admin-image{display:inline-block;vertical-align:middle;max-width:100%;cursor:pointer}
.main-table .admin-image,.ant-table-tbody .admin-image{width:40px!important;height:56px!important;display:inline-flex;align-items:center;justify-content:center}
.main-table .admin-image .ant-image,.ant-table-tbody .admin-image .ant-image{width:40px!important;height:56px!important}
.main-table .admin-image img,.ant-table-tbody .admin-image img{width:100%!important;height:100%!important;object-fit:contain}
</style>
